import React from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { loginEvent } from '../../_events/login/login.event';
import { message } from 'antd';
import { enterKeyHandler } from '../../_utils/keyboard_events';

const LoginForm = () => {

    const login = () => {
        loginEvent(true)
        .catch(err => {
            message.error(err.message);
        });
    }

    return(
        <div>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width:'100%'}}>
                    <img src={require('../../assets/imgs/koala_software_logo.png')} width={170} height={136} alt={'Koala Software'} />
                    <div style={{ fontWeight: 'bold', fontSize: '15px' }}>Login privado</div>
                    </div>
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="login" 
                        label="Usuario" 
                        variant="outlined"
                        size="small"
                        onKeyUp={(e) => {if(enterKeyHandler(e, () => login()));}}
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="pass" 
                        label="Contraseña" 
                        variant="outlined" 
                        type="password"
                        autoComplete="current-password" 
                        size="small"
                        onKeyUp={(e) => {if(enterKeyHandler(e, () => login()));}}
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <Button 
                        onClick={() => {login();}} 
                        style={{width: '100%'}} variant="contained">Entrar</Button>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}

export default LoginForm;
